import { CSSTransitionGroup } from "react-transition-group";
import styled from "styled-components";

const enter = "slide-in-enter";
const enterActive = "slide-in-enter-active";
const leave = "slide-in-leave";
const leaveActive = "slide-in-leave-active";
const timeout = 300;

const SlideIn = styled(CSSTransitionGroup).attrs({
  transitionName: { enter, enterActive, leave, leaveActive },
  transitionEnterTimeout: timeout,
  transitionLeaveTimeout: timeout
})`
  .${enter} {
    transform: translateY(-100%);
  }
  .${enterActive} {
    transform: translateY(0);
    transition: transform ${timeout}ms ease-out;
  }
  .${leave} {
    transform: translateY(0);
  }
  .${leaveActive} {
    transform: translateY(-100%);
    transition: transform ${timeout}ms ease-in;
  }
`;

export default SlideIn;



// WEBPACK FOOTER //
// ./src/animations/SlideIn.js